import { render } from "./MyAgreementsList.vue?vue&type=template&id=58a11934"
import script from "./MyAgreementsList.vue?vue&type=script&lang=js"
export * from "./MyAgreementsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__